import(/* webpackMode: "eager" */ "/codebuild/output/src4179575019/src/actions-runner/_work/eon-service/eon-service/frontend/apps/eon/src/app/error.tsx");
